import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';

import { STALE_TIME } from '@savgroup-front-common/constants';
import { CommonWorkflowService } from '@savgroup-front-common/core/api';
import { FileStateHistorySummary } from '@savgroup-front-common/core/api/Workflow/getFileStatesQuery';

export const GetMultipleFileStatesQuery = 'getMultipleFileStatesQuery';

export const useGetMultipleFileStatesQuery = ({
  fileIds,
}: {
  fileIds?: string[];
}) => {
  const { locale } = useIntl();

  const { data: multiHistories, refetch } = useQuery(
    [GetMultipleFileStatesQuery, { fileIds, locale }],
    async () => {
      if (!fileIds) {
        return undefined;
      }

      return Promise.all(
        fileIds?.map(async (fileId) => {
          const response = await CommonWorkflowService.getFileStatesQuery({
            fileId,
            language: locale,
          });

          if (response.failure) {
            return undefined;
          }

          return response.value;
        }),
      ).then(
        (value) =>
          value
            .filter((histories) => histories)
            .flat(1) as FileStateHistorySummary[],
      );
    },
    {
      staleTime: STALE_TIME.MINUTES_10,
      suspense: true,
    },
  );

  return {
    multiHistories,
    refetchHistories: refetch,
  };
};
